var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoLibrary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99967 8.33337H11.6663L9.36634 5.33337L7.83301 7.33337L6.79967 6.00004L4.99967 8.33337ZM4.33301 11C3.96634 11 3.65245 10.8695 3.39134 10.6084C3.13023 10.3473 2.99967 10.0334 2.99967 9.66671V1.66671C2.99967 1.30004 3.13023 0.986152 3.39134 0.725041C3.65245 0.46393 3.96634 0.333374 4.33301 0.333374H12.333C12.6997 0.333374 13.0136 0.46393 13.2747 0.725041C13.5358 0.986152 13.6663 1.30004 13.6663 1.66671V9.66671C13.6663 10.0334 13.5358 10.3473 13.2747 10.6084C13.0136 10.8695 12.6997 11 12.333 11H4.33301ZM4.33301 9.66671H12.333V1.66671H4.33301V9.66671ZM1.66634 13.6667C1.29967 13.6667 0.985786 13.5362 0.724674 13.275C0.463563 13.0139 0.333008 12.7 0.333008 12.3334V3.00004H1.66634V12.3334H10.9997V13.6667H1.66634Z",
    fill: "#627FE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoLibrary);
export default __webpack_public_path__ + "static/media/photo-library.94c2418e899611fe6d3f42f835b373e8.svg";
export { ForwardRef as ReactComponent };